const settings = {
  get(prop, defaultValue = null) { return this[prop] || defaultValue },

  'sample.value': 'foo'
};

export default settings;